import {
  disputeEvidenceSource,
  disputeReason,
  disputeSortableColumns,
  disputeSource,
  disputeStatus,
  disputeType,
} from "@redotech/redo-dispute-db-schema/dispute-definition";
import { SortDirectionSchema } from "@redotech/redo-views-common/table";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const reclaimDisputeRowSchema_ = z.object({
  id: z.coerce.string(),
  accountId: z.coerce.string(),
  source: z.enum(disputeSource),
  sourceDisputeId: z.string(),
  sourceOrderId: z.string().nullish(),
  type: z.enum(disputeType),
  status: z.enum(disputeStatus),
  reason: z.enum(disputeReason).nullish(),
  evidenceSource: z.enum(disputeEvidenceSource).nullish(),
  networkReasonCode: z.string().nullish(),
  amount: z.coerce.number(),
  currency: z.string(),
  evidenceDueBy: z.coerce.date().nullish(),
  evidenceSentOn: z.coerce.date().nullish(),
  finalizedOn: z.coerce.date().nullish(),
  initiatedAt: z.coerce.date(),
  rawDispute: z.unknown(),
  aiEvidenceGeneratedAt: z.coerce.date().nullish(),
  autoEvidenceDisabled: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  deletedAt: z.coerce.date().nullish(),
  teamName: z.string().nullish(),
  teamId: z.string().nullish(),
  hasEvidence: z.boolean(),
  reviewed: z.boolean(),
});

export const reclaimDisputeRowSchema: z.ZodType<ReclaimDisputeRow> =
  reclaimDisputeRowSchema_;
export interface ReclaimDisputeRow
  extends z.infer<typeof reclaimDisputeRowSchema_> {}

export const bankNameClassification = ["known", "unknown"] as const;
export type BankNameClassification = (typeof bankNameClassification)[number];

export const getReclaimDisputes = unaryRpc({
  name: "getReclaimDisputes" as const,
  input: z.object({
    offset: z.number().int().min(0).optional(),
    limit: z.number().int().min(1).max(1000).optional(),
    statuses: z.array(z.enum(disputeStatus)).optional(),
    bankNameClassification: z.enum(bankNameClassification).optional(),
    sort: z
      .object({
        sortBy: z.enum(disputeSortableColumns),
        sortDirection: SortDirectionSchema,
      })
      .optional(),
  }),
  // Total count is exposed via getReclaimDisputesCount so paging doesn't
  // re-COUNT(*) on every page change.
  output: z.object({ disputes: z.array(reclaimDisputeRowSchema_) }),
});
